import { Author } from "../../types/Author";
import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";

export async function createAuthor(authorData: Author): Promise<string> {
  const existingId =
    typeof authorData.id === "string" ? authorData.id.trim() : "";
  const authorRef = existingId
    ? firestore.collection(DB_PATH.AUTHOR).doc(existingId)
    : firestore.collection(DB_PATH.AUTHOR).doc();
  const newAuthorData = {
    ...authorData,
    id: authorRef.id,
  };
  await authorRef.set(newAuthorData);
  return authorRef.id;
}
